import { proxy } from 'valtio';

import type { AssetType } from './asset-types';

/**
 * 素材库全局 store — 使用 valtio 替代 V1 的 zustand
 */
export const assetLibraryStore = proxy({

  refreshTick: 0, // 刷新计数器，用于触发全局列表刷新
  scopeFilter: 'team' as 'project' | 'team', // 一级分类
  activeType: 'image' as 'image' | 'video' | 'audio', // 二级分类
  searchQuery: '', // 搜索
  searchType: undefined as 'node' | 'group' | 'ai' | 'upload' | undefined, // 搜索类型（可选）
  activeGroupId: null as string | null, // 选中的聚合项节点/分组 ID
});

export function setAssetLibraryFilters(filters: {
  scope?: 'project' | 'team',
  type?: 'image' | 'video' | 'audio',
  search?: string,
  searchType?: 'node' | 'group' | 'ai' | 'upload' | undefined,
  activeGroupId?: string | null,
}) {
  if (filters.scope) assetLibraryStore.scopeFilter = filters.scope;
  if (filters.type) assetLibraryStore.activeType = filters.type;
  if (filters.search !== undefined) assetLibraryStore.searchQuery = filters.search;
  if (filters.searchType !== undefined || 'searchType' in filters) {
    assetLibraryStore.searchType = filters.searchType;
    assetLibraryStore.activeGroupId = null; // searchType 改变，重置聚合项 ID
  }
  if (filters.activeGroupId !== undefined) assetLibraryStore.activeGroupId = filters.activeGroupId;
}



export function triggerAssetRefresh(type?: AssetType) {
  // 如果指定了类型，且当前选中的类型与之不符，则不刷新
  if (type && assetLibraryStore.activeType !== type) {
    return;
  }
  assetLibraryStore.refreshTick += 1;
}
